// System Modules
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule, } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgxTurnstileModule } from 'ngx-turnstile';
import { AppComponent } from '../app.component';


// Custom Modules
import { RoutingComponents, RoutingGuards, RoutingRoutes } from './routing.module';
import { MaterialModules, MaterialDateProviderLocale, MaterialDateProviderFormat, MaterialDateProviderAdapter } from './material.module';
import { NavigationComponents, LoginComponents, SharedComponents, AgentComponents, MemberComponents, WizardComponents, SharedFormComponents, SharedControlComponents, DialogComponents } from './components.module';
import { Services } from './services.module';

// Directives
import { AppDisableDirective } from 'src/app/directives/app-auto-disable.directive';
import { MaskDirective } from 'src/app/directives/text-mask.directive';
import { LabelControl } from 'src/app/directives/label-control.directive';

// Pipes
import { SafeHtmlPipe } from 'src/app/pipes/safe-html.pipe';
import { SafeURLPipe } from 'src/app/pipes/safe-url.pipe';
import { EnumKeysPipe } from 'src/app/pipes/enum-keys.pipe';
import { TranslatePipe } from 'src/app/pipes/translate.pipe';
import { DevExtremeModules } from './devExtreme.module';
import { MatIconModule } from '@angular/material/icon';
import { APIInterceptor } from '../services/api-interceptor.service';



/**
 * This must be done in this order or forms will not populate in shared componenets.
 * SharedControlComponents
 * SharedFormComponents
 * SharedComponents
 * ETC.. Components
 */

@NgModule({
    declarations: [
        AppComponent,
        EnumKeysPipe,
        SafeHtmlPipe,
        SafeURLPipe,
        TranslatePipe,
        AppDisableDirective,
        MaskDirective,
        LabelControl,
        RoutingComponents,
        NavigationComponents,
        SharedControlComponents,
        SharedFormComponents,
        SharedComponents,
        DialogComponents,
        LoginComponents,
        AgentComponents,
        MemberComponents,
        WizardComponents,
    ],
    bootstrap: [AppComponent],
    imports: [BrowserModule,
        BrowserAnimationsModule,
        ClipboardModule,
        CommonModule,
        FormsModule,
        MaterialModules,
        ReactiveFormsModule,
        RouterModule.forRoot(RoutingRoutes, {
            bindToComponentInputs: true,
            enableViewTransitions: true,
            scrollPositionRestoration: 'enabled',
        }),
        MatSnackBarModule,
        DevExtremeModules,
        NgxTurnstileModule],
    providers: [
        FormBuilder,
        Services,
        RoutingGuards,
        MaterialDateProviderLocale,
        MaterialDateProviderFormat,
        MaterialDateProviderAdapter,
        MatIconModule,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: APIInterceptor,
            multi: true
        }
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
